<div class="all-filters mt-2">
  <div class="flex-row space-between items-center pr-2">
    <a class="clear-button primary-menu-button" color="primary" mat-button (click)="onClearClick()">Clear Filter</a>
    <button mat-icon-button color="primary" class="close" (click)="onApplyClick()">
      <mat-icon color="primary">check</mat-icon>
    </button>
  </div>

  @if (showAuctionTypeFilter) {
    <div class="pl-3"><b>Listing Type</b></div>
    <mat-checkbox
      color="primary"
      class="ml-4 primary-checkbox"
      [checked]="auctionTypeSelection.isEmpty()"
      (change)="toggleAllAuctionTypes($event.checked)">
      All
    </mat-checkbox>
    @for (at of auctionTypes; track at.id) {
      <div class="mat-elevation-z0">
        <mat-checkbox
          color="primary"
          class="ml-4 primary-checkbox"
          [checked]="isAuctionTypeChecked(at)"
          (click)="$event.stopPropagation()"
          (change)="toggleAuctionType(at)">
          {{ at.name }}
        </mat-checkbox>
      </div>
    }
  }

  <div class="pl-3"><b>Property Type</b></div>
  <mat-checkbox
    color="primary"
    class="ml-4 primary-checkbox"
    [checked]="subTypeSelection.isEmpty()"
    (change)="toggleAllPropertyTypes($event.checked)">
    All
  </mat-checkbox>
  <mat-accordion>
    @for (pt of propertyTypes; track pt.id) {
      <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isPropertyTypeChecked(pt)"
            [indeterminate]="isPropertyTypeIndeterminate(pt)"
            (click)="$event.stopPropagation()"
            (change)="togglePropertyType(pt)">
            {{ pt.name }}
          </mat-checkbox>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="flex-col">
            @for (pst of pt.subTypeList; track pst.id) {
              <div>
                <mat-checkbox
                  color="primary"
                  class="primary-checkbox"
                  [checked]="isSubTypeChecked(pst)"
                  (change)="toggleSubType(pst)">
                  {{ pst.name }}
                </mat-checkbox>
              </div>
            }
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <div class="pl-3"><b>States</b></div>
  <mat-checkbox
    color="primary"
    class="ml-4 primary-checkbox"
    [checked]="stateSelection.isEmpty()"
    (change)="toggleAllStates($event.checked)">
    All
  </mat-checkbox>
  @for (s of states; track s.id) {
    <div class="mat-elevation-z0">
      <mat-checkbox
        color="primary"
        class="ml-4 primary-checkbox"
        [checked]="isStateChecked(s)"
        (click)="$event.stopPropagation()"
        (change)="toggleState(s)">
        {{ s.name }}
      </mat-checkbox>
    </div>
  }

  <div class="pl-3"><b>Sale Type</b></div>
  <mat-checkbox
    color="primary"
    class="ml-4 primary-checkbox"
    [checked]="saleTypeSelection.isEmpty()"
    (change)="toggleAllSaleTypes($event.checked)">
    All
  </mat-checkbox>
  @for (st of saleTypes; track st.id) {
    <div class="mat-elevation-z0">
      <mat-checkbox
        color="primary"
        class="ml-4 primary-checkbox"
        [checked]="isSaleTypeChecked(st)"
        (click)="$event.stopPropagation()"
        (change)="toggleSaleType(st)">
        {{ st.name }}
      </mat-checkbox>
    </div>
  }

  <div class="pl-3 mb-2"><b>Property Features</b></div>
  <form [formGroup]="propertyFeaturesForm" class="mx-3">
    <div class="flex-row flex-wrap space-between">
      <mat-form-field class="w-45" (click)="$event.stopPropagation()">
        <mat-label>Beds</mat-label>
        <mat-select formControlName="beds">
          @for (value of bedRoomFilterValues; track value) {
            <mat-option [value]="value">
              {{ value.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-45" (click)="$event.stopPropagation()">
        <mat-label>Baths</mat-label>
        <mat-select formControlName="baths">
          @for (value of bathRoomFilterValues; track value) {
            <mat-option [value]="value">
              {{ value.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-45" (click)="$event.stopPropagation()">
        <mat-label>Sqft Min</mat-label>
        <input matInput formControlName="areaFrom" onlyNumber>
      </mat-form-field>
      <mat-form-field class="w-45" (click)="$event.stopPropagation()">
        <mat-label>Sqft Max</mat-label>
        <input matInput formControlName="areaTo" onlyNumber>
      </mat-form-field>
      <mat-form-field class="w-45" (click)="$event.stopPropagation()">
        <mat-label>Garages</mat-label>
        <mat-select formControlName="garages">
          @for (value of garageFilterValues; track value) {
            <mat-option [value]="value">
              {{ value.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
